import React from 'react';
import { FiPlus, FiTrash2 } from 'react-icons/fi';
import PropTypes from 'prop-types';
import SimpleInput from 'src/components/SimpleInput';
import TextButton from 'src/components/TextButton';
import uuid from 'uuid';
import { IntentArgumentActions, IntentArgumentTypeContent, IntentField } from './style';

export const getDefaultMultipleChoiceData = () => ({
  value: '',
  id: uuid.v4()
});

export default function IntentTypeChoices({ data, onChange }) {
  return (
    <IntentField alignItems="flex-start">
      <p>Choices</p>
      <IntentArgumentTypeContent>
        {data?.map(choice => (
          <div key={choice.id}>
            <SimpleInput
              value={choice.value}
              onChange={e => {
                onChange(
                  data.map(el => (el.id === choice.id ? { ...choice, value: e.target.value } : el))
                );
              }}
              placeholder="Value of the choice"
            />
            <IntentArgumentActions>
              <button
                type="button"
                onClick={() => onChange(data.filter(el => el.id !== choice.id))}
              >
                <FiTrash2 />
              </button>
            </IntentArgumentActions>
          </div>
        ))}
        <TextButton
          onClick={() => onChange([...data, getDefaultMultipleChoiceData()])}
          type="button"
        >
          <FiPlus /> Add Choice
        </TextButton>
      </IntentArgumentTypeContent>
    </IntentField>
  );
}

IntentTypeChoices.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string
    })
  ).isRequired,
  onChange: PropTypes.func.isRequired
};
